import { render, staticRenderFns } from "./Tmg1.vue?vue&type=template&id=3a32f64a&scoped=true"
import script from "./Tmg1.vue?vue&type=script&lang=js"
export * from "./Tmg1.vue?vue&type=script&lang=js"
import style0 from "./Tmg1.vue?vue&type=style&index=0&id=3a32f64a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a32f64a",
  null
  
)

export default component.exports